(function () {
  'use strict';

  function buildMobileHeading(root) {
    var pdp = root.querySelector('.pdp');
    var info = root.querySelector('.pdp-info');
    var gallery = root.querySelector('.gal');
    if (!pdp || !info || !gallery) return;
    if (pdp.querySelector(':scope > .yarn-mobile-heading')) return;

    var intro = info.querySelector(':scope > .pdp-intro') || info;
    var kick = intro.querySelector(':scope > .kick');
    var title = intro.querySelector(':scope > h1');
    var rating = intro.querySelector(':scope > .yarn-rating-link, :scope > .rate-empty');
    var priceRow = intro.querySelector(':scope > .pricerow');
    var vat = intro.querySelector(':scope > .vat');
    if (!kick && !title && !priceRow && !vat) return;

    var heading = document.createElement('div');
    heading.className = 'yarn-mobile-heading';
    heading.setAttribute('data-yarn-mobile-heading', '');

    if (kick) heading.appendChild(kick.cloneNode(true));
    if (title) {
      var mobileTitle = document.createElement('h2');
      mobileTitle.innerHTML = title.innerHTML;
      heading.appendChild(mobileTitle);
    }
    if (rating) heading.appendChild(rating.cloneNode(true));
    if (priceRow) heading.appendChild(priceRow.cloneNode(true));
    if (vat) heading.appendChild(vat.cloneNode(true));

    pdp.insertBefore(heading, gallery);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.mvc-pdp-yarn').forEach(buildMobileHeading);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
